<template>
    <div class="organ-manage-layout">
        <div class="organ-manage-layout-left">
            <div class="organ-manage-layout-left-search">
                <el-input placeholder="查询机构" style="width: 224px;" prefix-icon="el-icon-search" v-model="filterText" />
                <div class="organ-manage-layout-left-search-btn-img" @click="addDgmxEvent('root')"></div>
            </div>
            <div class="organ-manage-layout-left-tree">
                <el-tree ref="orgTreeDom" highlight-current :data="orgTree" :indent="32" node-key="id" class="organ-manage-tree" :props="treeProps" :filter-node-method="filterNode" @node-click="orgFilter" default-expand-all :expand-on-click-node="false">
                    <div class="organ-manage-tree-item" slot-scope="{ node, data }">
                        <span :class="['organ-manage-tree-item-left', node.level === 1 ? '' : 'sub-tree']">
                            <j-svg-icon v-if="node.level === 1" name="org-jd"/>
                            <j-svg-icon v-else name="org-sq"/>
                            {{ data.name }}
                        </span>
                        <span class="organ-manage-tree-item-right">
                            <span v-if="node.level === 1" @click.stop="addDgmxEvent('tree', data)">
                                <j-svg-icon name="org-add"/>
                            </span>
                            <span @click.stop="editDgmxEvent(data, node)" style="margin: 0 8px;">
                                <j-svg-icon name="org-edit"/>
                            </span>
                            <span @click.stop="delEvent(data)">
                                <j-svg-icon name="org-del"/>
                            </span>
                        </span>
                    </div>
                </el-tree>
            </div>
        </div>
        <div class="organ-manage-layout-right">
            <div class="organ-manage-layout-right-title">
                机构人员
                <span class="organ-manage-layout-left-search-btn" @click="addUser"><j-svg-icon name="org-add"/></span>
            </div>
            <div class="organ-manage-layout-right-content">
                <user-manage ref="userListDom"  :search="false"/>
            </div>
        </div>

        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="400px" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth">
                <el-form-item label="机构类型">
                    <el-input :value="dgmxForm.parentType" placeholder="机构类型" readonly />
                </el-form-item>
                <el-form-item v-if="dgmxForm.parentType == '社区'" label="上级机构">
                    <el-input v-model="dgmxForm.parentName" placeholder="上级机构" readonly />
                </el-form-item>
                <el-form-item label="机构名称" prop="name">
                    <el-input v-model="dgmxForm.name" placeholder="请输入机构名称" clearable />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">确定</el-button>
                <el-button type="info" @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    import UserManage from "./UserManage";
    export default {
        name: "OrganManage",
        mixins: [PageMixins, DialogMixins],
        components: {
            UserManage
        },
        data () {
            return {
                treeProps: { children: 'childrens', label: 'name' },
                filterText: '',
                orgTree: [],
                dgmxForm: {
                    "name": "",
                    "parentId": '',
                    "sort": '',
                    parentName: '',
                    parentType: ''
                },
                dgmxRule: {
                    name: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
                }
            }
        },
        created () {
            // this.load()
        },
        watch: {
            filterText (val) {
                this.$refs.orgTreeDom.filter(val)
            }
        },
        methods: {
            updateOrgTree () {
                this.$store.dispatch('getOrgTree')
            },
            addUser () {
                this.$refs.userListDom.addDrmxEvent()
            },
            orgFilter (data) {
               this.$refs.userListDom.load(data)
            },
            filterNode (value, data, node) {
                if (!value) {
                    return true
                }
                // return data.name.indexOf(value) !== -1;
                return this.checkBelongToChooseNode(value, data, node)
            },
            checkBelongToChooseNode (value, data, node) {
                if (data.name.indexOf(value) !== -1) {
                    return true
                }
                const level = node.level
                // 如果传入的节点本身就是一级节点就不用校验了
                if (level === 1) {
                    return false
                }
                // 先取当前节点的父节点
                let parentData = node.parent
                // 遍历当前节点的父节点
                let index = 0
                while (index < level - 1) {
                    // 如果匹配到直接返回
                    if (parentData.data.name.indexOf(value) != -1) {
                        return true
                    }
                    // 否则的话再往上一层做匹配
                    parentData = parentData.parent
                    index++
                }
                // 没匹配到返回false
                return false
            },
            addDgmxEvent (type, data) {
                this.dgmxType = 'ADD'
                if (type === 'root') {
                    this.dgmxForm.parentId = ''
                    this.dgmxForm.parentType = '街道'
                    this.dgmxForm.parentName = ''
                } else {
                    console.log(data)
                    this.dgmxForm.parentType = '社区'
                    this.dgmxForm.parentName = data.name
                    this.dgmxForm.parentId = data.id
                }
                this.showDgmx = true
            },
            editDgmxEvent (data, node) {
                this.dgmxType = 'EDIT'
                this.curItem = { ...data }
                this.dgmxForm = this.proxyDgmxData({ ...data })
                console.log(data, node)
                if (!data.parentId) {
                    this.dgmxForm.parentId = ''
                    this.dgmxForm.parentType = '街道'
                    this.dgmxForm.parentName = ''
                } else {
                    console.log(data)
                    this.dgmxForm.parentType = '社区'
                    this.dgmxForm.parentName = node.parent.data.name
                }
                this.showDgmx = true
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前节点吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'delete',
                            url: `/api/orgs?id=${row.id}`
                        })
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.pageUpdate(this.query)
                            this.$message.success('删除成功')
                            this.load && this.load()
                            this.updateOrgTree()
                        })
                })
            },
            async load () {
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/orgs`)
                this.orgTree = data.data
                this.orgFilter(data.data[0] || {})
                this.tableLoading = false
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/orgs`
                if (this.dgmxType === 'EDIT') {
                    method = 'put'
                }
                const { data } = await this.$http[method](url, this.dgmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load()
                this.updateOrgTree()
            }
        }
    }
</script>

<style lang="scss">
    .organ-manage-layout {
        display: flex;
        position: relative;
        background: #F6F8FB!important;
        height: 100%;
        width: 100%;
        border-radius: 3px;
        box-shadow: 0 0 3px #dadada;
        .organ-manage-layout-left {
            min-width: 200px;
            margin-right: 5px;
            box-sizing: border-box;
            overflow-y: auto;
            padding: 16px;
            background-color: #fff;
            border-radius: 8px 0 0 8px;
            .organ-manage-layout-left-search {
                display: flex;
                margin-bottom: 17px;
                .organ-manage-layout-left-search-btn {
                    text-align: center;
                    line-height: 32px;
                    width: 32px;
                    height: 32px;
                    margin-left: 5px;
                    background-color: #7ACAFF;
                    cursor: pointer;
                }
            }
            .organ-manage-layout-left-search-btn-img {
                height: 32px;
                width: 32px;
                background-image: url("../../assets/OrganManage/org-search-add.png");
                background-size: cover;
                margin-left: 8px;
            }
            .organ-manage-layout-left-tree {
                .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
                    background: rgba(44, 162, 242, 0.05);
                    border-radius: 4px;
                }
                .el-tree-node__content:hover {
                    background: rgba(44, 162, 242, 0.05);
                    border-radius: 4px;
                    .organ-manage-tree-item-right {
                        display: block;
                    }
                    .organ-manage-tree-item-left {
                        color: #2CA2F2;
                    }
                }
            }
        }
        .organ-manage-layout-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            width: calc(100% - 500px);
            overflow-x: auto;
            height: 100%;
            padding: 0 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 0 8px 8px 0;
            .j-page-layout {
                position: initial;
            }
            .j-page-layout_wrap {
                position: initial;
                box-shadow: none;
            }
            .j-page-layout_wrap__table {
                padding: 0;
            }

            .organ-manage-layout-right-title {
                font-size: 16px;
                font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
                font-weight: normal;
                color: #2D363F;
                line-height: 26px;
                padding: 14px 0 0 16px;
            }
            .organ-manage-layout-right-content {
                flex: 1;
                min-height: 100px;
            }
        }

        .organ-manage-tree {
            .el-tree-node__content {
                height: auto;
                .el-tree-node__expand-icon {
                    position: relative;
                    z-index: 10;
                }
            }
            .el-tree-node__children {
                .el-tree-node:last-child {
                    .sub-tree {
                        position: relative;
                        &::before {
                            line-height: 90px;
                            top: -31px;
                        }
                    }
                }
            }
            .organ-manage-tree-item {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                padding-right: 10px;
                height: 40px;
                box-sizing: border-box;
                color: #727a83;
                /*background-color: #7ACAFF;*/
                > span {
                    display: inline-block;
                }
                .sub-tree {
                    position: relative;
                    &::before {
                        position: absolute;
                        content: '￣';
                        height: 40px;
                        line-height: 50px;
                        width: 10px;
                        top: -12px;
                        left: -25px;
                        color: #eee;
                        border-left: 1px solid #eee;
                    }
                }
                .organ-manage-tree-item-left {

                }
                .organ-manage-tree-item-right {
                    display: none;
                }
            }
        }
    }
</style>
